export const styles = {
  button: {
    marginLeft: 2,
  },
  deleteButton: {
    display: 'flex',
  },
};
